import { useAuthenticatedApi } from '@transport-insights/uikit';
import { useConfig } from '@src/context/config';

export default () => {
  const { PERFORMANCE_API_URL } = useConfig();
  const api = useAuthenticatedApi(PERFORMANCE_API_URL);

  return {
    async getCustomReportsList() {
      const url = '/dashboards/';
      const res = await api.get(url);
      return res?.data || [];
    },
    async getCustomReport(id) {
      const url = `/dashboards/${id}`;
      const res = await api.get(url);
      return res?.data || null;
    },
    async getAccessLevels() {
      const url = '/dashboards/access-levels/';
      const res = await api.get(url);
      return res?.data || [];
    },
    async createCustomReport(customReport) {
      const res = await api.post('/dashboards', { ...customReport }, {
        responseType: 'json',
      });
      return res?.data || null;
    },
    async deleteCustomReport(id) {
      const res = await api.delete(`/dashboards/${id}`);
      return res?.data || null;
    },
    async updateDisplayOrder(displayOrder) {
      const res = await api.post('/dashboards/display-order', [...displayOrder], {
        responseType: 'json',
      });
      return res?.data || null;
    },
  };
};
